<template>
  <v-card elevation="0">
    <v-card-title>
      <v-icon left color="orange darken-4">mdi-view-list</v-icon>Commandes
    </v-card-title>
    <v-card-text class="headline font-weight-bold">
      <template v-if="loading==false">{{orderCount}}</template>
      <v-progress-circular v-else indeterminate color="orange darken-2"></v-progress-circular>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    orderCount: 0,
    loading: false
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.orders()
        .then(data => {
          this.orderCount = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    ...mapActions("statistique", ["orders"])
  }
};
</script>

<style>
</style>